import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Card,
  CardContent,
  Typography,
  Stack,
} from "@mui/material";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import CodeIcon from "@mui/icons-material/Code";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { useTheme } from "@emotion/react";
import { requestGetAll } from "../API/request_server";
import CircularWithValueLabel from "./Loader";
import Message from "./Message";
import Grid from "@mui/material/Grid2";
import Heading from "./Heading";

const OurServices = () => {
  const [_servicesData, _setServicesData] = useState([]);
  const [_loader, _setLoader] = useState(false);

  const theme = useTheme();
  const getData = async () => {
    _setLoader(true);
    const result = await requestGetAll("services/getall");
    const data = result.data.map((item) => ({
      service_title: item.service_title,
      description: item.description,
      icon: item.icon
        ? `https://ptp.gkp.pk/backend_ptp_admin/${item.image}`
        : //? `http://localhost/backend_ptp_admin/${item.icon}`
          "https://via.placeholder.com/300",
    }));
    _setServicesData(data);
    _setLoader(false);
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <Box sx={{ py: { xs: 6, md: 5 }, background: "#f8fafc" }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 8 }}>
            <Heading _title="Services" />
            <Grid container spacing={3}>
              {_servicesData.map((item, index) => (
                <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                  <Card
                    sx={{
                      p: 3,
                      height: "100%",
                      borderRadius: "20px",
                      textAlign: "center",
                      boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                      transition: "0.3s",
                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: "0 12px 35px rgba(0,0,0,0.12)",
                      },
                    }}
                  >
                    <CardContent>
                      <img
                        src={item.icon}
                        alt={item.service_title}
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "12px",
                        }}
                      />

                      <Typography variant="h5" fontWeight={700} gutterBottom>
                        {item.service_title}
                      </Typography>

                      <Typography color="text.secondary">
                        {item.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <Heading _title="Meetings" />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default OurServices;
